module.exports = __webpack_public_path__ + "static/img/title-fr.a267cb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title/title-fr.png
// module id = dRFE
// module chunks = 1